import { ConversationFlowAuditLogEntry } from 'apis/auditLogs';

type RoutedThroughAgentAvailabilityProps = {
  node: ConversationFlowAuditLogEntry<'MESSENGER_AGENT_AVAILABILITY_NODE_VISITED'>;
};

export function RoutedThroughAgentAvailability({
  node,
}: RoutedThroughAgentAvailabilityProps): JSX.Element {
  return (
    <>
      Agent Availability
      {node?.was_available !== undefined && (
        <>
          ·{' '}
          <strong>{node.was_available ? 'Available' : 'Not available'} </strong>
        </>
      )}
    </>
  );
}
